/**
 * On page load
 **/
$(document).ready(function () {
    MobileNav();
    ToggleSearchBar();
    ToggleImageCaptions();
});

function MobileNav() {
    $('.c-header__menu-toggle').click(function () {
        const isOpen = $(this).toggleClass('open').hasClass('open');

        $(this).attr('aria-expanded', isOpen);
        $('.c-header__mainnav').toggleClass('open', isOpen);
        $('html, body').toggleClass('has-open-header-menu', isOpen);
    });
}

function ToggleSearchBar() {

    $('.c-header__search-toggle').click(function () {
        const search = $(this).closest('.c-header__search');
        const isOpen = search.toggleClass('open').hasClass('open');

        $(this).attr('aria-expanded', isOpen);

        if (isOpen) {
            search.find('input.query').trigger('focus');
        }
    });
}

function ToggleImageCaptions() {

    $('.credited-image .toggle').stop().click(function () {

        var target = $(this).siblings('.details');

        if ($(this).hasClass('fadein')) {
            target.fadeIn(100);
        } else {
            target.fadeOut(100);
        }

        $(this).toggleClass('fadein fadeout');

    });

}
